import React from 'react';
import { Images, LayoutGrid } from 'lucide-react';
import { StatusTag, EmptyState, CollapsibleCard } from '../../common';
import AdditionalSpaces from './AdditionalSpaces';
import ImageGrid, { NoImages } from './ImageGrid';
import { getImageUrl, categoryDisplayName, categoryShare } from './images.controller';

function CategoryCard({ category }) {
    const categoryName = categoryDisplayName(category);
    const share = categoryShare(category);
    const imagesBefore = category?.imagesBefore || [];
    const single = imagesBefore.length === 1;

    return (
        <div className="rounded-xl border border-surface-200 flex flex-col h-full">
            <div className="px-4 py-3 border-b border-surface-100">
                <span className="text-sm font-semibold text-surface-900">{categoryName}</span>
            </div>
            <div className="p-4 flex flex-col gap-3 flex-1">
                {imagesBefore.length > 0 ? (
                    <ImageGrid
                        images={imagesBefore}
                        getImageUrl={getImageUrl}
                        alt={categoryName}
                        height={single ? 140 : 68}
                        columns={single ? 'grid-cols-1' : 'grid-cols-2'}
                    />
                ) : (
                    <NoImages label="Sin imágenes" />
                )}

                <div className="mt-auto flex items-center justify-between rounded-lg bg-surface-50 px-3 py-2">
                    <span className="text-xs font-medium text-surface-500">Share of Shelf</span>
                    <StatusTag tone={share >= 50 ? 'success' : 'danger'} className="tabular-nums">
                        {!isNaN(share) ? share.toFixed(1) : '--'}%
                    </StatusTag>
                </div>

                {imagesBefore.length > 1 && <span className="text-xs text-surface-400 text-center">{imagesBefore.length} imágenes</span>}
            </div>
        </div>
    );
}

function AsesorImages({ storeCheck }) {
    const categories = storeCheck?.categories || [];
    const ourSpaces = storeCheck?.ourSpaces || [];
    const theirSpaces = storeCheck?.theirSpaces || [];

    return (
        <CollapsibleCard
            title="Categorías y Espacios"
            icon={<Images />}
            iconTone="brand"
            badges={<StatusTag tone="neutral">{categories.length} categorías</StatusTag>}>
            {categories.length === 0 ? (
                <EmptyState icon={<LayoutGrid />} title="Sin categorías" description="No hay categorías disponibles" />
            ) : (
                <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                    {categories.map((category, index) => (
                        <CategoryCard key={index} category={category} />
                    ))}
                </div>
            )}

            <AdditionalSpaces ourSpaces={ourSpaces} theirSpaces={theirSpaces} getImageUrl={getImageUrl} />
        </CollapsibleCard>
    );
}

export default AsesorImages;
